export const checkQuestionValidity = (question) => {
  let isValid = false;
  if (
    question &&
    question.question &&
    question.answers &&
    question.answers.length >= 3
  ) {
    const correctAnswers = question.answers.filter((answer) => {
      return answer.correct;
    });
    const checkForAnswerExist = !question.answers.find((answer) => {
      return !answer.answer;
    });
    if (correctAnswers.length === 1 && checkForAnswerExist) {
      isValid = true;
    }
  }
  return isValid;
};

export const filterValidQuestions = (questions = []) => {
  return questions.filter((question) => {
    return checkQuestionValidity(question);
  });
};

export const getQuizQuestions = (activeQuiz) => {
  let questions = [];
  if (activeQuiz && activeQuiz.questions) {
    questions = activeQuiz.questions;
  }
  return questions;
};

export const getCorrectAnswer = (question) => {
  return question.answers.find((answer) => answer.correct);
};

export const checkIsWithIconsType = (question) => {
  const answers = question.answers;
  let isIconsType = true;
  if (answers && Array.isArray(answers) && answers.length) {
    answers.forEach((answer) => {
      if (!answer.icon) {
        isIconsType = false;
      }
    });
  }
  return isIconsType;
};
